import { Extension } from "../../core/extension";
import { ReactNodeView } from "../../react/react-node-view";
import { insertPillNode } from "./helpers";
import { PillNodeView } from "./PillNodeView/PillNodeView";
import { pillNodeSpec } from "./schema";
/**
 * Declares the `pill` node type and its view representation.
 */
export class PillExtension extends Extension {
    addNodes(nodes) {
        return nodes.append(pillNodeSpec());
    }
    addNodeViews(schema, nodeViews, portalContainer) {
        return {
            ...nodeViews,
            pill: ReactNodeView.create({
                portalContainer,
                component: PillNodeView,
            }),
        };
    }
    addCommands() {
        return {
            addPill: (attrs) => ({
                active: () => false,
                enable: () => true,
                run: (state, dispatch, view) => {
                    insertPillNode(view, attrs);
                },
            }),
        };
    }
}
